import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActionSheetController, ModalController, NavParams } from 'ionic-angular';
import { TournamentService } from '../../../services/tournament.service';
import { ResultEditOnePage } from '../../edits/one-page/edit-one-page';



/**
 * Spielpaarung
 * Interface for plan
 */

@Component({
  selector: 'result-one',
  templateUrl: 'result-one.html',
})
export class GamerResultOnePage {

  @Input() activePlan: any = 0;
  @Input() header: boolean = true;

  constructor(
    private navParams: NavParams,
    private modalCtrl: ModalController,
    private gs: TournamentService,
    private actionCtrl: ActionSheetController,
    private translate: TranslateService
  ) { 
    this.activePlan = this.navParams.get('activePlan') || this.activePlan;
  }

  onOpenEdit(index: number){
    let modal = this.modalCtrl.create(ResultEditOnePage, { activePlan: this.activePlan, teamIndex: index });
    modal.present();
  }

  sort(){
    if(!this.gs.planList[this.activePlan]) return [];

    return this.gs.planList[this.activePlan].teams.sort((a, b) => b.points - a.points);
  }

  getGroupName(i: number){
    let ASCII = 65;
    return String.fromCharCode(ASCII + i);
  }

  onRemoveTeam(index: any){
      let sheet = this.actionCtrl.create({
        title: this.translate.instant('MYSPORT_PHOTOS_SHEET_TITLE'),
        buttons: [
          {
            text: this.translate.instant('MYSPORT_PHOTOS_SHEET_DELETE'),
            role: 'destructive',
            handler: () => {
              this.gs.planList[this.activePlan].gameTable[index.r].splice(index, 1);
              this.gs.save();
            }
          },
          {
            text: this.translate.instant('MYSPORT_PHOTOS_SHEET_CANCEL'),
            role: 'cancel',
            handler: () => {
              console.log('Cancel clicked');
            }
          }
        ]
      });
      sheet.present();
    }
}

export interface IPlanResults {
  id: number;
  gameDay: number;
  name: string;
  type: number;
  winner: number;
  team1: {
    result: number;
    points: number;
    id: number;
    name: string;
  };
  team2: {
    result: number;
    points: number;
    id: number;
    name: string;
  }
}






// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/results/result-one/result-one.ts